import { Button, InputAdornment } from "@material-ui/core";
import { get } from "lodash";
import RemoteErrorsInterceptor, { withErrors } from "ra-remote-validator";
import React from "react";
import {
	Edit as RaEdit,
	required,
	SaveButton,
	SimpleForm,
	TextInput,
	Toolbar as RaToolbar,
	useNotify,
	usePermissions,
	useRefresh,
	useTranslate,
} from "react-admin";
import { compose } from "recompose";
import { useFormStyles } from "../components/forms/useStyles";
import Title from "../components/Title";
import { API_URL } from "../config";
import PasswordInput from "../users/inputs/PasswordInput";
import PaymentMethodsInput from "../users/inputs/PaymentMethodInput";
import ReferralCodeInput from "./inputs/ReferralCodeInput";
import TaxInput from "./inputs/TaxInput";

const Toolbar = (props) => (
	<RaToolbar {...props}>
		<SaveButton />
	</RaToolbar>
);

const Edit = ({ dispatch, validate, errors, staticContext, ...props }) => {
	const { permissions } = usePermissions();
	const classes = useFormStyles();
	const notify = useNotify();
	const refresh = useRefresh();
	const translate = useTranslate();
	return (
		<RaEdit
			id="profile"
			resource="users"
			basePath="profile"
			redirect=""
			title={<Title source="email" />}
			mutationMode="pessimistic"
			{...props}
			classes={classes}
			onSuccess={(data) => {
				const isAdmin = get(data, "data.is_admin", false);
				if (!isAdmin) {
					notify("resources.user-profiles.user_on_success");
				}
				refresh();
			}}
		>
			<SimpleForm validate={validate} toolbar={<Toolbar />}>
				<RemoteErrorsInterceptor errors={errors} dispatch={dispatch} />
				<TextInput source="email" validate={required()} />
				<PasswordInput permissions={permissions} />
				<TextInput source="profile.name" validate={required()} />
				<TextInput source="profile.surname" validate={required()} />
				<TextInput source="profile.phone" validate={required()} />
				<ReferralCodeInput source="referral_code" readOnly />
				<TextInput source="profile.site_link" fullWidth validate={required()} />
				<TextInput
					source="profile.telegram_id"
					fullWidth
					disabled={true}
					label="ra.profile.fields.telegram_id"
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<Button
									href={`${API_URL}/bot/connect?token=${localStorage.getItem(
										"token"
									)}`}
									color="primary"
									target="_blank"
								>
									{translate("ra.action.connect")}
								</Button>
							</InputAdornment>
						),
					}}
				/>
				<TaxInput source="profile." fullWidth />
				<PaymentMethodsInput
					permissions={permissions}
					source="profile.payment_method"
				/>
			</SimpleForm>
		</RaEdit>
	);
};

export default compose(withErrors)(Edit);
